export const habaUser = {
  habaCommonUserInformation: {
    nameAndJob: '{{firstName}} {{lastName}}, {{job}}',
    profileImageAlt: 'Profilbild des Benutzers',
  },
  habaLoginForm: {
    heading: 'Willkommen zurück',
    checkoutHeading: 'Ich bin bereits Kunde im Online-Shop',
    newCustomer: 'Ich bin Neukunde im Online-Shop',
    next: 'Weiter',
    forgotPassword: 'Passwort vergessen?',
    signIn: 'Anmelden',
    register: 'Jetzt registrieren',
    dontHaveAccount: 'Noch kein Kundenkonto?',
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    password: {
      label: 'Passwort',
      passwordRequired: 'Bitte geben Sie Ihr Passwort ein',
    },
    guestCheckout: 'Als Gast bestellen',
    successfulLogin: 'Willkommen! Login erfolgreich',
    failedLogin:
      'Das hat leider nicht funktioniert. Bitte prüfen Sie, ob Sie die richtige E-Mail-Adresse und das richtige Passwort verwenden.',
    passwordExpired:
      '<strong>Ihr Passwort ist abgelaufen.</strong><br />Bitte <a href="{{url}}">setzen Sie ihr Passwort zurück</a>, damit Sie sich anmelden können.',
    reminderEmail: {
      title: 'E-Mail noch nicht bestätigt!',
      description:
        '<strong>Sie haben Ihre E-Mail-Adresse noch nicht bestätigt. Um sich bei uns anzumelden,</strong> Bitte bestätige deine E-Mail-Adresse, dann können wir dein Kundenkonto anlegen. Wir haben dir eine E-Mail geschickt. Klicke einfach auf den Bestätigungs-Link in der E-Mail.<br/><br/>Wenn Sie keine E-Mail erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner oder fordern Sie eine neue E-Mail an.',
      resendEmail: 'E-Mail erneut senden',
      infoTitle: 'Hinweis:',
      infoText:
        'Beachten Sie, dass der Link in der erhaltenen E-Mail <strong>nur 2 Stunden lang</strong> verfügbar ist.<br/><br/>Wenn Sie Ihre E-Mail-Adresse nicht bestätigen, wird <strong>Ihr Konto in 2 Wochen</strong> ab dem Zeitpunkt der Kontoregistrierung gelöscht. Vergessen Sie also nicht, auf den Bestätigungslink zu klicken.<br/><br/><strong>3 Tage</strong> vor der Löschung des <strong>Kontos erhalten</strong> Sie eine Erinnerungs-E-Mail mit einem Link, über den Sie eine neue Bestätigungs-E-Mail anfordern können.',
      activationLinkSent: 'Aktivierungs-E-Mail wurde erfolgreich gesendet.',
      activationLinkError:
        'Beim Senden der Aktivierungs-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    },
  },
  habaRegisterForm: {
    heading3: 'Registrierung',
    heading2: 'Rechnungsadresse',
    heading: 'Herzlich Willkommen',
    headingCheckout: 'Als Neu- oder Gastkunde bestellen',
    orderAsGuestText: 'Ich möchte als Gast bestellen',
    register: 'Jetzt Registrieren',
    registerAsGuest: 'Zur Gastbestellung',
    invoiceNotPossible: 'Bei einer Gastbestellung ist der Kauf auf Rechnung nicht möglich.',
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
      userAlreadyExists:
        'Zu dieser E-Mail-Adresse besteht bereits ein Kundenkonto. Bitte melden Sie sich an, um mit der Bestellung fortzufahren.',
    },
    password: {
      label: 'Passwort',
      labelText:
        'Damit Ihre Logindaten besonders sicher bleiben, können Sie Ihr Passwort jederzeit ändern.',
      passwordRequired:
        'Mindestens 6 Zeichen, mindestens ein Sonderzeichen, mindestens einen Großbuchstaben, mindestens einen Kleinbuchstaben, mindestens eine Zahl',
      passwordForbiddenCharsAndTooShort: 'Mindestens 6 Zeichen',
      passwordNoSpecialChars: 'Mindestens ein Sonderzeichen',
      passwordNoUpperCase: 'Mindestens einen Großbuchstaben',
      passwordNoLowerCase: 'Mindestens einen Kleinbuchstaben',
      passwordNoDigits: 'Mindestens eine Zahl',
      placeholder:'Bitte wählen Sie ein Passwort'
    },
    passwordRepeat: {
      label: 'Passwort wiederholen',
      passwordRequired: 'Passwort und Passwortwiederholung stimmen nicht überein',
    },
    postRegisterMessage: 'Registrierung erfolgreich! Bitte melden Sie sich an',
    firstName: {
      label: 'Vorname*',
      required: 'Pflichtfeld',
    },
    lastName: {
      label: 'Nachname',
      required: 'Pflichtfeld',
    },
    hasAccount: 'Sie haben bereits ein Kundenkonto?',

    hasAccountLink: 'Hier anmelden',
  },
  habaNavLogin: {
    login: 'Anmelden',
    register: 'Registrieren',
    logoutLink: 'Abmelden',
    logout: 'Nicht {{name}}?',
    successfulLogout: 'Logout erfolgreich.',
    modal: {
      headline: 'Mein Account',
    },
    myAccount: {
      overview: 'Übersicht',
      orders: 'Bestellungen',
      accountData: 'Kundendaten',
      deliveryAddresses: 'Meine Lieferadressen',
    },
  },
  habaForgottenPassword: {
    heading: 'Passwort zurücksetzen',
    headingNewPassword: 'Neues Passwort vergeben',
    save: 'speichern',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    checkInbox: 'Bitte prüfen Sie Ihr E-Mail-Postfach…',
    instructions:
      'Eine Anleitung zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet. Wenden Sie sich bitte an den Kundendienst, wenn Sie weitere Hilfe benötigen',
    errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.',
    tokenExpired:
      'Ihr Token ist abgelaufen. Bitte fordern Sie eine neue Passwort-Vergessen E-Mail an.',
    information: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    successFullUpdated: 'Ihr Passwort wurde aktualisiert',
    emailAddress: {
      label: 'E-Mail Adresse',
      wrongEmailFormat: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    submit: 'Senden',
    cancel: 'Zurück',
    infoText: {
      forgotPassword:
        'Bitte nutzen Sie die E-Mail Adresse, die Sie zur Registrierung Ihre Kontos verwendet haben. <br/> Wir senden dann einen Link. den Sie verwenden können, um ein neues Passwort zu vergeben.',
      resetMailSend: {
        firstPart:
          'Falls für die angegebene E-Mail-Adresse ein Benutzerkonto besteht, haben wir eine E-Mail zum Zurücksetzen Ihres Passworts an <b>{{ emailAddress }}</b> gesendet.',
        secondPart: 'Bitte folgen Sie dem Link in der E-Mail, um ein neues Passwort zu vergeben.',
      },
      noEmailInfo: {
        headline: 'Keine Nachricht erhalten?',
        reason1: 'Überprüfen Sie, ob die E-Mail-Adresse korrekt eingegeben wurde.',
        reason2: 'Prüfen Sie Ihren Spam-Ordner.',
        newUser: 'Falls für diese E-Mail-Adresse noch kein Benutzerkonto besteht, können Sie',
        newUserLinkText: 'hier ein neues Benutzerkonto erstellen.',
        backToAccount: 'Zurück zur Anmeldung',
      },
      resetPassword:
        'Damit dein Konto auch weiterhin sicher bleibt, muss dein Passwort mindestens die folgenden Zeichen beinhalten:',
    },
  },
  habaProRegisterForm: {
    deviatingEmailData: {
      headline: 'Abweichende Rechnungsempfänger-E-Mail (optional)',
      label: 'Abweichende E-Mail-Adresse für diese Rechnung',
      disclaimer:
        'Wir schicken die Rechnung an die hier angegebene E-Mail-Adresse. Weitere E-Mails zum Bestellvorgang (Bestellbestätigung etc.) schicken wir wie gewohnt an ihre E-Mail-Adresse.',
    },
    button: {
      cartOfferButton: 'Angebot Anfordern',
      nextRegisterPage: 'Jetzt registrieren',
      next: 'weiter',
      updateRegistration: 'Rechnungsadresse aktualisieren',
      submit: 'Jetzt registrieren',
      goToDeliveryStep: 'Weiter zur Lieferadresse',
      goToPaymentStep: 'Weiter zur Zahlungsart',
    },
    sponsorData: {
      name: 'Name*',
      nameExtension: 'Name Erweiterung (optional)',
      headerline: 'Träger Informationen',
      sponsorDataAccordion: 'Abweichender Rechnungsempfänger (optional)',
      disclaimer:
        'Die Rechnung wird nicht an Sie selbst, sondern an den einzutragenden Träger oder Organisation gestellt.',
    },
    form: {
      customerType: {
        private: 'Privatperson',
        firm: 'Firma',
        institution: 'Einrichtung',
        select: 'In welcher Rolle bestellen Sie?',
        firmSelected: 'Die Rechnung wird von einer Firma beglichen',
        institutionSelected:
          'Die Rechnung wird von einer Einrichtung oder einem Unternehmen beglichen.',
        privateSelected: 'Die Rechnung wird von mir oder einer anderen Privatperson beglichen.',
      },
      gtc: 'Ich erkenne die <strong>Datenschutzerklärung</strong> sowie die <strong>AGBs</strong> von Wehrfritz an. Sie haben per Gesetz ein 14-tägiges Widerrufsrecht. Einzelheiten und Ausnahmen dazu in unserer <strong>Widerrufsbelehrung</strong>.',
      disabledFieldsError: 'Bitte treffen Sie eine Auswahl',
    },
    industrySelection: {
      nurseryDay: 'Kinderkrippen',
      dayCare: 'Tagesmutter/Großtagespflege',
      dayCareCenter: 'Kindertagesstätten',
      district: 'Landkreis',
      city: 'Stadt/Gemeinde',
      therapists: 'Therapeuten',
      socialWards: 'Sozialstationen/ambulante Pflege',
      retirement: 'Seniorenheim',
      medicalPractice: 'Arztpraxen',
      supportAssociation: 'Kita-/Schul-Förderverein',
      afterSchoolCare: 'Hort',
      pupilCare: 'Schülerbetreuung',
      elementarySchool: 'Grundschule/Volksschule',
      specialSchool: 'Sonderschule',
      comprehensiveSchool: 'Gesamtschule',
      middleSchool: 'Haupt-/Mittelschule',
      secondarySchool: 'Realschule',
      highSchool: 'Gymnasium',
      otherSchool: 'Andere Schulen',
      other: 'Sonstige Branche',
    },
    formError: {
      gtc: 'Bitte die AGB akzeptieren.',
      phoneNumberFormat: 'Bitte im Format: 4912345678',
      zipCodeLength: 'Die Postleitzahl muss {{length}} Stellen lang sein.',
    },
    messages: {
      postRegisterMessage:
        '<b>Bestätigen Sie Ihre E-Mail Adresse, damit wir Ihr Kundenkonto anlegen können.</b><br/>Wir haben Ihnen eine E-Mail gesendet. Klicken Sie darin einfach auf den Bestätigungs-Link.',
      userAlreadyExists: 'Nutzer existiert bereits.',
      userAlreadyExistsEnterOrResetPass:
        'Zu dieser E-Mail-Adresse existiert bereits ein Kundenkonto bei HABA. Melde dich <a href="{{loginUrl}}">hier</a> an oder klicke auf <a href="{{forgotPassUrl}}">Passwort vergessen</a> falls du deine Anmelde-Daten vergessen hast',
      unexpectedError: 'Hoppla, da ist etwas schiefgelaufen',
      updateAddress: 'Addresse wurde aktualisiert.',
    },
  },
  habaAccountOverview: {
    personalProfile: 'Persönliches Profil',
    personalProfileMessage:
      'Dies ist dein persönliches {{ storeName }} Profil, hier findest du alle wichtigen Informationen und jede Menge Inspirationen!',
    pageTitle: 'Willkommen in ihrem Kundenkonto',
    pageDescription: '',
    customerType: {
      institution: 'Einrichtung',
      carrier: 'Träger',
      association: 'Verein',
      company: 'Unternehmen',
      private: 'Privatkunde',
    },
    card: {
      orders: {
        title: 'Meine Bestellungen',
        text: 'Öffnen Sie hier Ihre getätigten Bestellungen.',
        btnText: 'Zur Bestellübersicht',
      },
      wishlist: {
        title: 'Meine Merklisten',
        text: 'Öffnen und bearbeiten Sie hier Ihre vorgemerkten Produkte.',
        btnText: 'Zu den Merklisten',
      },
      customerData: {
        title: 'Meine Kundendaten',
        text: 'Bearbeiten Sie hier Ihre persönlichen Kundendaten.',
        btnText: 'Zu meinen Daten',
      },
      delivery: {
        title: 'Meine Lieferadressen',
        text: 'Bearbeiten Sie hier Ihre Lieferadressen.',
        btnText: 'Zu den Lieferadressen',
      },
    },
  },
  habaCustomerData: {
    authorizationGroup: {
      trigger: 'Warum kann ich diese Daten nicht ändern?',
      notice: 'Die Kundendaten können nur in Absprache mit dem Kundenservice geändert werden.',
      serviceHoursTitle: 'Unsere Servicezeiten',
      serviceDays: 'Montag bis Freitag:',
      serviceTime: '8:00 Uhr bis 16:00 Uhr',
    },
    pendingSapEnrichment: {
      trigger: 'Warum kann ich diese Adresse nicht ändern?',
      title: 'Diese Adresse wird noch bearbeitet',
      notice:
        'Die Adresse wird gerade in unserem System angelegt. Sobald das abgeschlossen ist, ist eine Änderung wieder möglich.',
    },
    loginData: {
      changeEmailAndSave: 'E-Mail ändern & speichern',
      changeLoginData: 'Logindaten ändern',
      changeError: 'Bitte vergewissern dich, dass du das richtige Passwort verwendest.',
      changePasswordAndSave: 'Passwort ändern & speichern',
      confirmNewEmail: 'Neue E-Mail Adresse bestätigen',
      confirmNewPassword: 'Neues Passwort bestätigen',
      currentEmail: 'Aktuelle E-Mail Adresse:',
      currentPassword: 'Aktuelles Passwort',
      currentPasswordRequired: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
      emailsMustMatch: 'E-Mail Adressen müssen übereinstimmen',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
      newEmail: 'Neue E-Mail Adresse',
      newPassword: 'Neues Passwort',
      emailUpdated: 'E-Mail-Adresse wurde aktualisiert',
      passwordUpdated: 'Passwort wurde aktualisiert',
    },
    deliveryAddress: {
      button: 'Neue Lieferadressen',
      title: 'Lieferadressen',
      globalMessage: {
        updated: 'Lieferadresse aktualisiert',
        added: 'Lieferadress hinzugefügt',
      },
      list: {
        headline: 'Meine Lieferadressen',
        phoneNumber: 'Tel.-Nr.',
        btn: {
          new: 'Neue Lieferadresse hinzufügen',
          newMobile: 'Neue Lieferadresse',
          delete: 'Entfernen',
          edit: 'Bearbeiten',
        },
        defaultDeliveryAddress: 'Standard Lieferadresse',
        isBillingAddress: 'Rechnungsadresse',
      },
      new: {
        headline: 'Lieferadresse hinzufügen',
        btn: {
          add: 'hinzufügen',
          cancel: 'Zurück ohne Änderung',
        },
      },
      edit: {
        headline: 'Lieferadresse bearbeiten',
        btn: {
          update: 'aktualisieren',
          cancel: 'Zurück ohne Änderung',
        },
      },
      modal: {
        headline: 'Lieferadresse entfernen?',
        pendingOrder:
          'Ausstehende Bestellungen werden nicht storniert, die an diese Adresse gesendet werden.',
        btn: {
          cancel: 'Abbrechen',
          delete: 'Entfernen',
        },
      },
    },
    billingAddress: {
      title: 'Rechnungsadressen',
      subtitle: 'Aus diesen Rechnungsadressen können Sie beim Kauf wählen',
      defaultBillingAddress: 'Standard Rechnungsadresse',
      button:'Neue Rechnungsadressen',
      addNew: 'Neue Rechnungsadresse hinzufügen',
            new: {
        headline: 'Rechnungsadresse hinzufügen',
        btn: {
          add: 'hinzufügen',
          cancel: 'Zurück ohne Änderung',
        },
      },
      edit: {
        headline: 'Rechnungsadresse bearbeiten',
        btn: {
          update: 'aktualisieren',
          cancel: 'Zurück ohne Änderung',
        },
      },
    },
    overview: {
      address: 'Anschrift',
      billingAddress: 'Rechnungsadresse',
      emailAddress: 'E-Mail Adresse',
      loginData: 'Login Daten',
      myData: 'Meine Daten',
      name: 'Name',
      noBillingAddress: 'Sie haben noch keine Rechnungsadresse.',
      password: 'Passwort',
      personalData: 'Persönliche Daten',
      phoneNumber: 'Telefonnummer',
    },
    updateData: {
      headline: 'Persönliche Daten',
      updateButton: 'Aktualisieren',
      successMessage: 'Persönliche Daten wurden erfolgreich geändert.',
    },
    invoiceDownload: {
      headline: 'Rechnungsanforderung',
      part1Headline: '1. Sie haben Ihre Rechnungsnummer zur Hand?',
      part1Description:
        'Einfach hier herunterladen. Geben Sie in den nachfolgenden Eingabefeldern Ihre Kundennummer und Ihre Rechnungsnummer ein und klicken Sie auf Herunterladen.<br/>Aus Datenschutzgründen wird im Hintergrund geprüft, ob Kundennummer und Rechnungsnummer zusammengehören - nur dann ist das Herunterladen möglich.<br/>Sie können immer nur eine Rechnung herunterladen. Bei mehreren Rechnungen müssen Sie diese Schritte nacheinander ausführen.',
      part2Headline: '2. Ihnen liegt lediglich die Auftragsnummer vor?',
      part2Description:
        'Geben Sie in den nachfolgenden Eingabefeldern Ihre Kundennummer und Ihre Auftragsnummer ein und klicken Sie auf Herunterladen.<br/>Aus Datenschutzgründen wird im Hintergrund geprüft, ob Kundennummer und Auftragsnummer zusammengehören - nur dann ist das Herunterladen möglich.<br/>Sie finden beide Angaben (Kunden- und Auftragsnummer) auf der Ihnen vorab zugesendeten Auftragsbestätigung.<br/>Es werden Ihnen alle zum angegebenen Auftrag verfügbaren Rechnungen angezeigt.',
      inputCustomerNr: 'Geschäftspartner / Kundennummer',
      inputInvoiceNr: 'Belegnummer / Rechnungsnummer oder Auftragsnummer',
      inputCustomerNrError: 'Die Angabe der Kundennummer ist notwendig.',
      inputInvoiceNrError: 'Die Angabe der Rechnungsnummer ist notwendig.',
      submitButton: 'Rechnung herunterladen',
      notFound:
        'Eine Rechnung für die angegebene Kundennummer und Rechnungsnummer konnte nicht gefunden werden.',
    },
    orderStatus: {
      inputError: 'Die Angabe einer Nummer ist notwendig',
      customerNrFormatError:
        'Die Kundennummer darf maximal 10 Ziffern enthalten und nur aus Zahlen bestehen',
      headline: 'Bestellstatus / Lieferstatus',
      info: 'Sehr geehrte Kund*innen,<br/><br/>mit Hilfe dieser Abfrage können Sie den Lieferstatus Ihrer Bestellung abrufen.<br/><br/>Bitte beachten Sie, dass wir zur Anzeige der Daten die richtige Kombination der zum Auftrag gehörenden Kunden- und Auftragsnummer benötigen. Bei Bestellungen mit vielen Positionen kann die Abfrage eine Sekunden dauern. Bitte haben Sie einen Moment Geduld.',
      inputText: 'Geben Sie ihre Kundennummer und Auftragsnummer ein',
      customerNumberText: 'Kundennummer / Business Partner Nummer',
      orderNumberText: 'Auftragsnummer',
      submitText: 'Bestellstatus anzeigen',
      startsWithNineAndTenDigits: 'Die Auftragsnummer beginnt mit einer 9 und ist 10-stellig',
      onlyDigits: 'Die Auftragsnummer besteht nur aus Ziffern',
    },
  },
  habaOrderHistory: {
    myOrders: 'Meine Bestellungen',
    orderFrom: 'Bestellung vom',
    orderNumber: 'Auftragsnummer',
    status: 'Status',
    total: 'Gesamtsumme',
    viewOrder: 'Bestellung Anzeigen',
    trackOrder: 'Verfolgen',
  },
  habaNewsletterProcess: {
    subscription: {
      title: 'Jetzt zum Wehrfritz Newsletter anmelden!',
      description:
        'Erfahren Sie zudem alles über innovative Ansätze und Entwicklungen im Bereich der pädagogischen Architektur und Bildung.',
      seoTitle: 'Newsletter abonnieren',
      submit: 'Jetzt gratis anmelden',
      subHeadline: 'Ihre ausgewählte Themengebiete',
      atLeastOne: 'Bitte wählen Sie ihre gewünschten Themengebiete.',
      submitError:
        'Entschuldigen Sie, leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie unseren Kundenservice.',
      submitSuccess:
        'Wir haben Ihnen eine E-Mail an folgende Adresse gesendet: {{email}} Bitte bestätigen Sie Ihre Newsletter-Anmeldung!',
      secondTopicHeadline: 'Raumkonzepte, Möbelsysteme und Lehr- und Lernmittel für',
      topics: {
        all: 'Alle Themengebiete',
        1: 'Krippe & Kindergarten',
        2: 'Schule & Nachmittagsbetreuung',
        15: 'Raumkonzepte für familienfreundliche Geschäftsräume',
        5: 'Ganzheitliches Heilen: Therapie & Pflege am Kind',
      },
      isAgreed: {
        label:
          'Ich erkenne die <a href="{{privacyUrl}}" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a> sowie die <a href="{{termsUrl}}" target="_blank" rel="noopener noreferrer">AGBs</a> von Wehrfritz an. Sie haben per Gesetz ein 14-tägiges Widerrufsrecht. Einzelheiten und Ausnahmen dazu in unserer <a href="{{cancellationUrl}}" target="_blank" rel="noopener noreferrer">Widerrufsbelehrung</a>',
        error:
          'Bitte bestätigen Sie, dass Sie unsere AGB und Datenschutzerklärung gelesen und akzeptiert haben.',
      },
      email: {
        label: 'E-Mail Adresse',
        error: 'Bitte E-Mail Adresse eingeben',
      },
    },
    unsubscribeSuccess: 'Sie wurden erfolgreich von unserem Newsletter abgemeldet.',
  },
  habaBillingAddress: {
    messages: {
      success: 'Ihre Rechnungsadresse wurde erfolgreich aktualisiert',
    },
  },
  habaRegistrationBenefits: {
    title: 'Jetzt registrieren und sofort profitieren!',
    subtitle: 'Erstellen Sie ein Kundenkonto und profitieren Sie sofort von diesen Vorteilen:',
    benefits: {
      one: 'Bezahlen per Rechnung',
      two: 'Lieferstatus und Ihre gesamte Bestellhistorie im Überblick',
      three: 'Erstellung von mehreren Merklisten',
      four: 'Verwaltung verschiedener Liefer- und Rechnungsadressen',
      five: 'Unverbindliche individuelle Vorabangebote anfordern',
    },
  },
  habaChat: {
    iconName: 'Sie',
  }
};
